import React from 'react';
import '../App.css';
import white from './images/white.png';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

export default function What() {
  const { ref, inView } = useInView({ triggerOnce: true ,  threshold: 0.3 });

  return (
    <div className="what-section d-flex flex-column text-light">
      <h1 className="gradient-text mt-5 text-center">What & Why</h1>

      <div className="container my-auto">
        <div className="row align-items-center ">

          {/* Text Section */}
          <div className="col-12 col-xl-6 mt-4 mt-lg-0">
            <motion.div
              ref={ref}
              initial={{ opacity: 0, y: 80 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 1.2, delay: 0.3, ease: "easeOut" }}
            >
              <div className="mb-4 fs-6">
                <h2 className="gradient-text">What?</h2>
                <p className="gradient-text">
                  PMS (Production Management System) is a centralized software solution that helps businesses plan, monitor, and manage every stage of the production lifecycle — from order intake to final delivery.
                </p>
              </div>

              <div className='fs-6'>
                <h2 className="gradient-text">Why?</h2>
                <p className="gradient-text">
                  Managing production manually or through disconnected tools leads to inefficiencies, delays, and costly errors. MDQ’s (PMS) brings everything under one roof — helping businesses move faster, stay organized, and make smarter decisions.
                </p>
              </div>
            </motion.div>
          </div>

          {/* Image Section */}
          <div className="col-12 col-xl-6 text-center">
            <motion.img
              ref={ref}
              src={white}
              alt="White laptop"
              className="img-fluid"
              initial={{ opacity: 0, y: 80 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 1.0, delay: 0.3, ease: "easeOut" }}
            />
          </div>

        </div>
      </div>
    </div>
  );
}
